<template>
  <TemplateListNormal
    v-if="boardTypeCode === 'normal'"
    :boardTitle="boardTitle"
    :postList="postList"
    :perPageOption="perPageOption"
    :perPage="Number(perPage)"
    :searchKeyword="searchKeyword"
    :currentPage="currentPage"
    :lastPage="lastPage"

    @handleChangePerPage = "handleChangePerPage"
    @handleItemClickDetail = "handleItemClickDetail"
    @handleSearch = "handleSearch"
    @handleChangePage = "handleChangePage"
    @handleClickRegister = "handleClickRegister"
    @handleItemClickModify = "handleItemClickModify"
    @handleItemClickDelete = "handleItemClickDelete"
  ></TemplateListNormal>

  <TemplateListWebzine
    v-else-if="boardTypeCode === 'webzine'"
    :boardTitle="boardTitle"
    :postList="postList"
    :perPageOption="perPageOption"
    :perPage="Number(perPage)"
    :searchKeyword="searchKeyword"
    :currentPage="currentPage"
    :lastPage="lastPage"

    @handleChangePerPage = "handleChangePerPage"
    @handleItemClickDetail = "handleItemClickDetail"
    @handleSearch = "handleSearch"
    @handleChangePage = "handleChangePage"
    @handleClickRegister = "handleClickRegister"
    @handleItemClickModify = "handleItemClickModify"
    @handleItemClickDelete = "handleItemClickDelete"
  ></TemplateListWebzine>

  <TemplateListGallery
    v-else-if="boardTypeCode === 'gallery'"
    :boardTitle="boardTitle"
    :postList="postList"
    :perPageOption="perPageOption"
    :perPage="Number(perPage)"
    :searchKeyword="searchKeyword"
    :currentPage="currentPage"
    :lastPage="lastPage"

    @handleChangePerPage = "handleChangePerPage"
    @handleItemClickDetail = "handleItemClickDetail"
    @handleSearch = "handleSearch"
    @handleChangePage = "handleChangePage"
    @handleClickRegister = "handleClickRegister"
    @handleItemClickModify = "handleItemClickModify"
    @handleItemClickDelete = "handleItemClickDelete"
  ></TemplateListGallery>

  <TemplateListShowHide
    v-else-if="boardTypeCode === 'showhide'"
    :boardTitle="boardTitle"
    :postList="postList"
    :perPageOption="perPageOption"
    :perPage="Number(perPage)"
    :searchKeyword="searchKeyword"
    :currentPage="currentPage"
    :lastPage="lastPage"

    @handleChangePerPage = "handleChangePerPage"
    @handleItemClickDetail = "handleItemClickDetail"
    @handleSearch = "handleSearch"
    @handleChangePage = "handleChangePage"
    @handleClickRegister = "handleClickRegister"
    @handleItemClickModify = "handleItemClickModify"
    @handleItemClickDelete = "handleItemClickDelete"
  ></TemplateListShowHide>

  <div v-else>
    {{ boardSlug }}
  </div>
</template>

<script>
import TemplateListNormal from '@/views/board/template/list/TemplateListNormal'
import TemplateListWebzine from '@/views/board/template/list/TemplateListWebzine'
import TemplateListGallery from '@/views/board/template/list/TemplateListGallery'
import TemplateListShowHide from '@/views/board/template/list/TemplateListShowHide'
import VueCookie from 'vue-cookie'

export default {
  name: 'BoardList',
  components: {
    TemplateListNormal,
    TemplateListWebzine,
    TemplateListGallery,
    TemplateListShowHide
  },
  data () {
    return {
      boardId:'',
      boardSlug: '',
      boardTypeCode: 'normal',
      perPageOption: '10,20,30',
      boardTitle: '',
      postList:[],

      //pagination
      perPage: 10,
      searchKeyword: '',
      currentPage: 1,
      lastPage: 1
    }
  },

  created () {

    this.boardSlug = this.$route.params.boardslug

    if (this.boardSlug === 'notice') {
      // ** boardslug를 이용하여 smardi_maotboard_boards 테이블의 데이터를 가져와야 한다.
      this.boardTypeCode = 'normal'
      this.boardTitle = '공지사항'
      this.boardId = '1'
    } else if (this.boardSlug === 'gallery') {
      // ** boardslug를 이용하여 smardi_maotboard_boards 테이블의 데이터를 가져와야 한다.
      this.boardTypeCode = 'gallery'
      this.boardTitle = '공지사항'
      this.boardId = '1'

      // gallery 용
      this.perPageOption = '8,12,16'
      this.perPage = '8'
    } else if (this.boardSlug === 'webzine') {
      // ** boardslug를 이용하여 smardi_maotboard_boards 테이블의 데이터를 가져와야 한다.
      this.boardTypeCode = 'webzine'
      this.boardTitle = '공지사항'
      this.boardId = '1'
    } else if (this.boardSlug === 'showhide') {
      // ** boardslug를 이용하여 smardi_maotboard_boards 테이블의 데이터를 가져와야 한다.
      this.boardTypeCode = 'showhide'
      this.boardTitle = '공지사항'
      this.boardId = '1'
    } else if (this.boardSlug === 'faq') {
      // ** boardslug를 이용하여 smardi_maotboard_boards 테이블의 데이터를 가져와야 한다.
      this.boardTypeCode = 'normal'
      this.boardTitle = 'FAQ'
      this.boardId = '3'
    } else if (this.boardSlug === 'service') {
      // ** boardslug를 이용하여 smardi_maotboard_boards 테이블의 데이터를 가져와야 한다.
      this.boardTypeCode = 'normal'
      this.boardTitle = '고객센터'
      this.boardId = '4'
    }

    // 게시물 정보
    const tableCurrentPage = VueCookie.get('table_current_page')
    const tablePerPage = VueCookie.get('table_per_page')
    const tableSearchKeyword = VueCookie.get('table_search_keyword')
    VueCookie.set('table_current_page', '')
    VueCookie.set('table_per_page', '')
    VueCookie.set('table_search_keyword', '')
    if (tableCurrentPage) { this.currentPage = Number(tableCurrentPage) }
    if (tablePerPage) { this.perPage = Number(tablePerPage) }
    if (tableSearchKeyword) { this.searchKeyword = tableSearchKeyword }

    this.loadPostList()

  },

  methods : {
    // 게시물 불러오기
    async loadPostList () {
      const boardId = this.boardId
      const page = (this.currentPage) ? this.currentPage : 1
      const keyword = (this.keyword) ? this.keyword : ''
      const perPage = this.perPage

      await this.$store.dispatch('board/LOAD_POST_LIST', {boardId, page, perPage, keyword})

      // 게시물 불러오기
      const postListInfo = this.$store.state.board.postListInfo

      // 페이지네이션 정보
      this.currentPage = postListInfo.current_page
      this.searchKeyword = keyword
      this.lastPage = postListInfo.last_page
      this.perPage = postListInfo.per_page

      // 보여지는 게시물 리스트
      this.postList = postListInfo.data

      VueCookie.set('table_current_page', this.currentPage)
    },


    // 게시물과 관련된 쿠키저장
    saveCookieBoard () {
      const currentPage = this.currentPage
      const perPage = this.perPage
      const searchKeyword = this.searchKeyword

      VueCookie.set('table_current_page', currentPage)
      VueCookie.set('table_per_page', perPage)
      VueCookie.set('table_search_keyword', searchKeyword)
    },


    // 글 등록페이지로 이동
    movePostRegister () {
      this.saveCookieBoard()
      this.$router.push({ path: `./${this.boardSlug}/create` })
    },
    // 글 상세페이지로 이동
    movePostDetail (_postId) {
      this.saveCookieBoard()
      this.$router.push({path: `./${this.boardSlug}/${_postId}`})
    },
    // 글 수정페이지로 이동
    movePostModify (_postId) {
      this.saveCookieBoard()
      this.$router.push({path: `./${this.boardSlug}/${_postId}/update`})
    },
    // 글 삭제
    async deletePost (_postId) {
      this.saveCookieBoard()
      const boardId = this.boardId
      const postId = _postId
      if (_postId <= 0) {
        return
      }
      await this.$store.dispatch('board/DELETE_POST', {boardId, postId})
      await this.loadPostList()
    },


    handleChangePerPage (_data) {
      if (this.perPage !== _data) {
        this.currentPage = 1
        this.perPage = _data
        this.loadPostList()
      }
    },
    handleSearch (_data) {
      if (this.keyword !== _data) {
        this.currentPage = 1
        this.keyword = _data
        this.loadPostList()
      }
    },
    handleChangePage (_data) {
      if (this.currentPage !== _data) {
        this.currentPage = _data
        this.loadPostList()
      }
    },
    handleItemClickDetail (_data) {
      this.movePostDetail(_data.id)
    },
    handleClickRegister () {
      this.movePostRegister()
    },
    handleItemClickModify (_data) {
      this.movePostModify(_data.id)
    },
    handleItemClickDelete (_data) {
      this.deletePost(_data.id)
    }
  }
}
</script>

<style scoped>

</style>
